import { FollowListLikeContainer, FollowListFollowersContainer } from "./follow-list";
import FollowingTabs from "./following-tabs";

export {
    FollowListLikeContainer,
    FollowListFollowersContainer,
}

export default FollowingTabs;